export const projectAboutData = {
    title: "My Projects 🔨",
    content: "As you probably can see if you've visited my github, most of my projects are in private repos, this is because they are branded and paid for, I do have plans re-branding and open-sourcing relevant projects once the time is right!",
    
}